// Lecturas de la lista de casos Cofidis: primero el VPS, que no cuesta
// lecturas de Firestore, y si no contesta, la consulta de Firestore de siempre.
//
// Las dos fuentes dan lo mismo (scripts/vpsCacheServer.js, queryCasos): mismo
// orden, mismos filtros y el mismo corte por páginas. Un cursor vale para las
// dos: la fecha y el id del último caso de la ventana, y su DocumentSnapshot
// cuando vino de Firestore, que es lo que pide `startAfter`.
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { consultarCasos, contarCasos, espejoConfigurado } from '../shared/vpsMirror';

const deSnap = (snap) => ({
  caso: { id: snap.id, ...snap.data() },
  cursor: { fecha: snap.get('registeredDate'), id: snap.id, snap },
});

/**
 * Una ventana de casos. `alRecibir` recibe `[{ caso, cursor }]`; con Firestore
 * puede llamarse dos veces (caché del navegador y luego servidor), igual que
 * antes. `firestore(despuesSnap, entregar)` hace la consulta de siempre.
 */
export async function leerCasos({ filtros, tokens = [], limite, despues = null, firestore, alRecibir, usarEspejo = true }) {
  if (usarEspejo && espejoConfigurado() && (!despues || typeof despues.fecha === 'string')) {
    let ventana = null;
    try {
      const casos = await consultarCasos({
        operacionesAgent: filtros.operacionesAgent,
        comercialAgent: filtros.comercialAgent,
        tokens,
        limite,
        despues: despues ? { fecha: despues.fecha, id: despues.id } : null,
      });
      ventana = casos.map(({ id, fila }) => ({ caso: fila, cursor: { fecha: fila.registeredDate, id } }));
    } catch (error) {
      ventana = null;
    }
    if (ventana) {
      alRecibir(ventana);
      return;
    }
  }
  // Un cursor que vino del VPS no trae el documento: se lee (una lectura) para
  // seguir desde el mismo sitio.
  let snap = despues ? despues.snap || null : null;
  if (despues && !snap) snap = await getDoc(doc(getFirestore(), 'cofidisCases', despues.id));
  await firestore(snap, (docs) => alRecibir(docs.map(deSnap)));
}

/** El total de la lista (count() con los filtros de agente). */
export async function contarCasosDelEspejo(filtros, firestore, usarEspejo = true) {
  if (usarEspejo && espejoConfigurado()) {
    try {
      return await contarCasos({ operacionesAgent: filtros.operacionesAgent, comercialAgent: filtros.comercialAgent });
    } catch (error) {
      // Firestore, como antes.
    }
  }
  return firestore();
}
